import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/mp-psi-simulation", { params });
};

const getAllForCSV = params => {
  return restApiMP.get("/api/mp-psi-simulation/csv", { params });
};

const getProductionPlan = params => {
  return restApiMP.get("/api/mp-psi-simulation/production-plan", { params });
};

const updateSimulationData = data => {
  return restApiMP.post("/api/mp-psi-simulation", data);
}

const mpPsiSimulationService = {
  getAll,
  getAllForCSV,
  getProductionPlan,
  updateSimulationData
};

export default mpPsiSimulationService;